import React from 'react';

export type DirectionContextType = 'ltr' | 'rtl';

const DirectionContext = React.createContext('ltr');

export default DirectionContext;
